import { ObApp } from '@/__generated__/types';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useSelectedAPPRadio = (): { OBAppRadioGroups: () => JSX.Element; selectedOBAppValue: ObApp } => {
    const { t } = useTranslation();
    const [selectedOBAppValue, setSelectedOBAppValue] = useState(ObApp.OrderbuddyApp);
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setSelectedOBAppValue(event.target.value as ObApp);
    };

    const OBAppRadioGroups = useCallback((): JSX.Element => {
        return (
            <FormControl component="fieldset">
                <RadioGroup row name="OBApp" value={selectedOBAppValue} onChange={handleRadioChange}>
                    {Object.values(ObApp).map((status) => (
                        <FormControlLabel
                            key={status}
                            value={status}
                            control={<Radio />}
                            label={t(status.charAt(0).toUpperCase() + status.slice(1))}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        );
    }, [selectedOBAppValue, t]);

    return { OBAppRadioGroups, selectedOBAppValue };
};
